export const defaultValues = {
  costType: '',
  paymentMethod: '',
  paymentMethodName: '',
  costName: '',
  costDate: '',
  currency: 'ISK',
  country: '',
  city: '',
  amount: '',
  carbonEmission: '',
  comment: '',
  attachments: [] as File[],
};
